import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faPenToSquare, faTrashAlt, faTrashAltSlash, faThumbsUp, faChevronUp, faChevronDown, faPaperPlaneTop, faLockKeyhole, faLockKeyholeOpen, faBan, faCircleCheck, faBug, faStar as faStarFal, faFilter, faSort, faFilterCircleXmark, faGraduationCap, faInfoCircle, faCircleExclamation, faCircleXmark, faBold, faItalic, faListUl, faLink, faTextSlash, faCodeCompare, faChartLine, faGear, faUserGraduate, faBook, faSliders, faText, faUser as faUserFal, faLanguage as faLanguageFal, faWandMagicSparkles, faHandSparkles, faCubes, faGift, faCommentDots } from '@fortawesome/pro-light-svg-icons' // fal
import { } from '@fortawesome/pro-thin-svg-icons' // fat
import { faMagnifyingGlass } from '@fortawesome/pro-duotone-svg-icons' // fad
import { faCheck, faXmark } from '@fortawesome/sharp-solid-svg-icons' // fass
import { faBallotCheck, faPlay } from '@fortawesome/pro-regular-svg-icons' // far
import { } from '@fortawesome/sharp-light-svg-icons' // fasl
import { } from '@fortawesome/sharp-thin-svg-icons' // fat
import { } from '@fortawesome/sharp-duotone-solid-svg-icons' // fad
import { faPlus, faStar as faStarFas, faArrowRightToBracket, faLocationDot, faPrint, faCopy, faUserEdit, faLink as faLinkFas, faEnvelope, faUser, faUsers, faCalendarAlt, faUserGroup, faEdit, faInfoCircle as faInfoCircleFas, faTimes, faSave, faTrash, faExclamationTriangle, faUsersClass, faUserPlus, faTasks, faLanguage, faArrowUpRightFromSquare, faGear as faGearFal, faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons' // fas
import { } from '@fortawesome/pro-thin-svg-icons'

/* add icons to the library */
library.add(faPenToSquare, faTrashAlt, faUserPlus, faCheck, faXmark, faThumbsUp, faChevronUp, faChevronDown, faUser, faPaperPlaneTop, faLockKeyhole, faLockKeyholeOpen, faTrashAltSlash, faMagnifyingGlass, faPlus, faBug, faBan, faCircleCheck, faStarFas, faStarFal, faArrowRightToBracket, faFilter, faSort, faLocationDot, faFilterCircleXmark, faGraduationCap, faInfoCircle, faCircleExclamation, faPrint, faCopy, faUserEdit, faLink, faEnvelope, faCircleXmark, faBold, faItalic, faListUl, faLinkFas, faTextSlash, faCodeCompare, faChartLine, faGear, faUserGraduate, faBook, faSliders, faText, faUser, faUsers, faCalendarAlt, faUserGroup, faEdit, faInfoCircleFas, faTimes, faSave, faTrash, faExclamationTriangle, faUsersClass, faUserFal, faBallotCheck, faTasks, faLanguage, faLanguageFal, faArrowUpRightFromSquare, faWandMagicSparkles, faHandSparkles, faCubes, faGift, faGearFal, faChevronLeft, faChevronRight, faPlay, faCommentDots)

const app = createApp(App)

// after app creation
app.component('font-awesome-icon', FontAwesomeIcon)

app.use(createPinia())
app.use(router)

app.mount('#app')
